export const environment = {
  production: true,

  //@ts-ignore
  hammerApiUrl: window['env']?.['hammerApiUrl'] || 'https://mycar.tekom.pl/web/api',
  //@ts-ignore
  nostromoAuthApiUrl: window['env']?.['nostromoAuthApiUrl'] || 'https://mycar.tekom.pl/auth/api/v2',
  //@ts-ignore
  genesisApiUrl: window['env']?.['genesisApiUrl'] || 'https://mycar.tekom.pl/mycar/api/v2',
  //@ts-ignore
  logosApiUrl: window['env']?.['logosApiUrl'] || 'https://mycar.tekom.pl/logos/api/v2',

  //@ts-ignore
  wsVehicleDataChangeServiceUrl: window['env']?.['wsVehicleDataChangeServiceUrl'] || 'wss://mycar.tekom.pl/web/ws_params',
  //@ts-ignore
  wsEventServiceUrl: window['env']?.['wsEventServiceUrl'] || 'wss://mycar.tekom.pl/web/ws_notify',

  //@ts-ignore
  isChristmasEvent: window['env']?.['isChristmasEvent'] || false,

  hotjarId: 2926715
};
